import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getMyWalletDetails } from '../../../../api/MyWalletAPI';
import AppBreadCrumb from '../../../common/AppBreadCrumb';
import AppPaginator from '../../../AppPaginator';
import PerPageBlock from '../../../common/PerPageBlock';

const MyWalletPage = () => {
    const navigate = useNavigate();
    const [walletDetails, setWalletDetails] = useState({ balance: 0, transactions: { data: [], last_page: 0 } });
    const [isLoading, setIsLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(15);
    
    // State for the new ledger form
    const [dateRange, setDateRange] = useState({
        from_date: new Date().toISOString().slice(0, 10),
        to_date: new Date().toISOString().slice(0, 10),
    });

    useEffect(() => {
        setIsLoading(true);
        const filters = { page: currentPage, per_page: perPage };
        getMyWalletDetails(filters, (response) => {
            if (response) {
                setWalletDetails(response);
            }
            setIsLoading(false);
        });
    }, [currentPage, perPage]);

    const handleDateChange = (e) => {
        setDateRange(prev => ({ ...prev, [e.target.name]: e.target.value }));
    };

    const handleViewLedger = () => {
        // Navigate to the new ledger page with dates as URL parameters
        navigate(`/club_portal/my-wallet/ledger?from=${dateRange.from_date}&to=${dateRange.to_date}`);
    };

    return (
        <main>
            <div className="container-fluid">
                <AppBreadCrumb title="My Wallet" />
                <div className="row">
                    {/* Balance Card */}
                    <div className="col-lg-6">
                        <div className="card text-center bg-primary text-white mb-4 h-100">
                            <div className="card-body">
                                <h5 className="card-title">Current Wallet Balance</h5>
                                <h1 className="display-4 text-white">₹{Number(walletDetails.balance).toFixed(2)}</h1>
                                {/* <button className="btn btn-light mt-2"><i className="fas fa-plus-circle me-2"></i>Add Funds (Coming soon)</button> */}
                            </div>
                        </div>
                    </div>

                    {/* New Ledger Form Card */}
                    <div className="col-lg-6">
                         <div className="card mb-4 h-100">
                            <div className="card-header"><h5>View Ledger Statement</h5></div>
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-md-6 mb-3">
                                        <label className="form-label">From Date</label>
                                        <input type="date" className="form-control" name="from_date" value={dateRange.from_date} onChange={handleDateChange} />
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <label className="form-label">To Date</label>
                                        <input type="date" className="form-control" name="to_date" value={dateRange.to_date} onChange={handleDateChange} />
                                    </div>
                                </div>
                                <button className="btn btn-primary w-100" onClick={handleViewLedger}>
                                    <i className="fas fa-file-alt me-2"></i>View Ledger
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* Transaction History Card */}
                    <div className="col-12">
                        <div className="card">
                            <div className="card-header"><h5>Recent Transaction History</h5></div>
                          <div className="card-body">
                                {isLoading ? (
                                    <div className="text-center"><div className="spinner-border"></div></div>
                                ) : walletDetails.transactions.data.length > 0 ? (
                                    <div className="table-responsive">
                                        <table className="table table-hover">
                                            <thead>
                                                <tr>
                                                    <th>Date</th>
                                                    <th>Description</th>
                                                    <th>Type</th>
                                                    <th className="text-end">Amount</th>
                                                    <th className="text-end">Balance</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {walletDetails.transactions.data.map(tx => (
                                                    <tr key={tx.id}>
                                                        <td>{new Date(tx.transaction_date).toLocaleString()}</td>
                                                        <td>{tx.description}</td>
                                                        <td>
                                                            <span className={`badge bg-light-${tx.type === 'credit' ? 'success' : 'danger'}`}>
                                                                {tx.type}
                                                            </span>
                                                        </td>
                                                        <td className={`text-end ${tx.type === 'credit' ? 'text-success' : 'text-danger'}`}>
                                                            {tx.type === 'credit' ? '+' : '-'} ₹{Number(tx.amount).toFixed(2)}
                                                        </td>
                                                        <td className="text-end">₹{Number(tx.balance_after_transaction).toFixed(2)}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                ) : (
                                    <p>No recent transactions found.</p>
                                )}
                            </div>
                            <div className="card-footer d-flex justify-content-between">
                                <AppPaginator totalPages={walletDetails.transactions.last_page} currentPage={currentPage} setCurrentPage={setCurrentPage} />
                                <PerPageBlock perPage={perPage} setPerPage={setPerPage} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );
};

export default MyWalletPage;

